module.exports = __webpack_public_path__ + "static/shadow_demon-75d9cef4fffbee6a5f69398325e7b631.jpeg";